import { render, staticRenderFns } from "./sub1.vue?vue&type=template&id=44d1703e&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44d1703e')) {
      api.createRecord('44d1703e', component.options)
    } else {
      api.reload('44d1703e', component.options)
    }
    module.hot.accept("./sub1.vue?vue&type=template&id=44d1703e&lang=pug&", function () {
      api.rerender('44d1703e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sample/sample/sub1.vue"
export default component.exports